import { SVGFC } from '@repo/toolkit/types'

const EtaDocumentIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.4668 11.0784C4.4668 7.45828 4.4668 5.64772 5.57803 4.52356C6.68831 3.39844 8.47652 3.39844 12.052 3.39844H13.9483C17.5237 3.39844 19.312 3.39844 20.4222 4.52356C21.5335 5.64772 21.5335 7.45828 21.5335 11.0784V14.9184C21.5335 18.5386 21.5335 20.3492 20.4222 21.4733C19.312 22.5984 17.5237 22.5984 13.9483 22.5984H12.052C8.47652 22.5984 6.68831 22.5984 5.57803 21.4733C4.4668 20.3492 4.4668 18.5386 4.4668 14.9184V11.0784Z"
        stroke={color}
        strokeWidth="1.06667"
      />
      <path
        d="M10.8204 14.0829V14.7988H8.6187V14.0829H10.8204ZM8.93404 10.6625V14.7988H8.0079V10.6625H8.93404ZM10.5363 12.3272V13.0204H8.6187V12.3272H10.5363ZM10.8232 10.6625V11.3812H8.6187V10.6625H10.8232ZM13.2579 10.6625V14.7988H12.3346V10.6625H13.2579ZM14.5164 10.6625V11.3812H11.1017V10.6625H14.5164ZM16.3687 11.4494L15.3005 14.7988H14.3119L15.8431 10.6625H16.4681L16.3687 11.4494ZM17.2551 14.7988L16.184 11.4494L16.0732 10.6625H16.7068L18.2437 14.7988H17.2551ZM17.2096 13.2591V13.975H15.0534V13.2591H17.2096Z"
        fill={color}
      />
    </svg>
  )
}

export default EtaDocumentIcon
